/**
 * حالتان صريحتان بدل الرقم المخترع:
 *
 *   `قيد الإطلاق`              — الميزة تحتاج محرّكاً لم يُنفّذ بعد (FV/OP/CF/MP).
 *   `لا توجد بيانات كافية بعد` — المحرّك ليس المشكلة، البيانات هي.
 *
 * ممنوع منعاً باتاً عرض قيمة تجريبية في مكان أي منهما داخل تجربة LIVE.
 */

import { color } from '@/design/tokens';

export type UnavailableReason = 'coming-soon' | 'insufficient-data';

const TEXT: Record<UnavailableReason, string> = {
  'coming-soon': 'قيد الإطلاق',
  'insufficient-data': 'لا توجد بيانات كافية بعد',
};

export function UnavailableBadge({ reason }: { reason: UnavailableReason }): JSX.Element {
  return (
    <span
      data-testid={`unavailable-${reason}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 9px',
        borderRadius: 6,
        border: `1px solid ${color.hairline}`,
        color: color.label,
        fontSize: 11.5,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {TEXT[reason]}
    </span>
  );
}

export function UnavailablePanel({
  reason,
  title,
  detail,
}: {
  reason: UnavailableReason;
  title: string;
  detail?: string;
}): JSX.Element {
  return (
    <div
      data-testid={`unavailable-${reason}`}
      style={{
        border: `1px dashed ${color.hairlineHard}`,
        borderRadius: 14,
        padding: 22,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <h3 style={{ fontSize: 15, fontWeight: 600 }}>{title}</h3>
        <UnavailableBadge reason={reason} />
      </div>
      <p style={{ marginTop: 10, fontSize: 12.5, color: color.textSubtle, lineHeight: 1.7 }}>
        {detail ??
          (reason === 'coming-soon'
            ? 'هذه الميزة تحتاج محرّكاً لم يُطلق بعد. لن نعرض رقماً تقديرياً مكانه.'
            : 'لم تصل بعد بيانات كافية من المصدر الرسمي لإصدار هذا الرقم.')}
      </p>
    </div>
  );
}
